import type { SelectBoxDisplayItem } from "./selectBox.types";

// `searchText` must already be lower-cased.
export default function matchesItemSearch(
  item: SelectBoxDisplayItem,
  searchText: string,
): boolean {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- ?? would keep an empty name instead of falling back to item.label
  const name = item.name?.toLowerCase() || item.label?.toLowerCase();

  return Boolean(name?.includes(searchText) || item.uuid?.includes(searchText));
}
